module.exports = __webpack_public_path__ + "static/media/see-analytics.d314023a.png";